<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="sAPPurchaseOrderDetails"
        @select="selectHandle"
        @select-all="selectHandle">
      <div slot="toolbar">
        <el-button v-if="createAuth" type="primary" @click="createDeliverySlip">创建送货单</el-button>
        <el-button type="primary" :loading="exportLoading" @click="exportExcel()">导出</el-button>
<!--        <div style="background: #fff1f0;color: red;border: 1px solid #ff0000;font-size: 12px;font-weight: bold;padding-left: 5px">-->
<!--          <p>注意：本页面将在6月底关闭，创建送货单请在【采购管理-采购订单管理V2】页面执行</p>-->
<!--        </div>-->
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="采购订单：">
            <el-input 
                v-model.trim="filter.purchaseOrderNo" 
                type="textarea" 
                autosize 
                placeholder="请输入采购单号" 
                clearable/>
          </vm-search>
          <vm-search label="物料编号：">
            <el-input v-model.trim="filter.partNO" placeholder="请输入物料编号" clearable/>
          </vm-search>
          <vm-search label="直发标识：">
            <el-select v-model.trim="filter.straightMark" placeholder="请选择">
              <el-option label="全部" :value="-1"/>
              <el-option label="直发" :value="0"/>
              <el-option label="非直发" :value="1"/>
            </el-select>
          </vm-search>
          <vm-search label="到货日期：" style="width:200px">
            <div class="block">
              <el-date-picker
                  v-model="filter.deliveryDateBegin"
                  placeholder="请选择"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 140px"/>
            </div>
          </vm-search>
          <vm-search label="至" style="width:200px;margin-left:15px">
            <div class="block">
              <el-date-picker
                  v-model="filter.deliveryDateEnd"
                  placeholder="请选择"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 140px"/>
            </div>
          </vm-search>
          <vm-search label="出厂编号：">
            <el-input 
                v-model.trim="filter.pcorderNo"
                type="textarea"
                placeholder="请输入出厂编号" 
                autosize
                clearable/>
          </vm-search>
          <vm-search label="仓位：">
            <el-input
                v-model.trim="filter.location"
                placeholder="请输入仓位"
                autosize
                clearable/>
          </vm-search>
          <vm-search label="送货状态：">
            <el-select v-model.trim="filter.isFinished" placeholder="请选择">
              <el-option label="全部" :value="-1"/>
              <el-option label="已完成" :value="0"/>
              <el-option label="未完成" :value="1"/>
            </el-select>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column
          prop="supplierName"
          align="left"
          label="供应商"
          min-width="180"
          show-overflow-tooltip/>
      <el-table-column
          prop="evaluate"
          align="center"
          label="采购订单"
          width="120"
          show-overflow-tooltip/>
      <el-table-column prop="rowNum" align="center" label="行号" width="100"/>
      <el-table-column
          prop="partNo"
          align="center"
          label="物料编号"
          width="140"
          show-overflow-tooltip/>
      <el-table-column
          prop="partNameSpec"
          align="left"
          label="物料描述"
          min-width="180"
          show-overflow-tooltip/>
      <el-table-column prop="responseDeliveryTime" align="center" label="交货期" width="100">
        <template slot-scope="scope">
          <span>{{scope.row.responseDeliveryTime ? scope.row.responseDeliveryTime.substring(0, 10) : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="pCorderNo"
          align="center"
          label="出厂编号"
          width="140"
          show-overflow-tooltip/>
      <el-table-column prop="straightMark" align="center" label="直发标识" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.straightMark === '1000'">非直发</span>
          <span v-if="scope.row.straightMark === 'Z001'">直发</span>
        </template>
      </el-table-column>
      <el-table-column prop="buyUserName" align="center" label="采购组" width="80"/>
      <el-table-column prop="zsign" align="center" label="溯源需求" width="80"/>
      <el-table-column prop="qty" align="center" label="采购订单数量" width="80"/>
      <el-table-column prop="hasInStorageQty" align="center" label="采购订单入库数量" width="80"/>
      <el-table-column prop="receiveHasInStorageQty" align="center" label="送货单已收数量" width="80"/>
      <el-table-column prop="location" align="center" label="仓位" width="80"/>
      <el-table-column prop="unit" align="center" label="单位" width="80"/>
    </vm-table>
    <create-delivery-bill-dialog ref="createDeliveryBillDialog" @save-success="getList(1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import CreateDeliveryBillDialog from "./CreateDeliveryBillDialog.vue";

  export default {
    name: "PurchaseDeliveryList",
    components: { VmTable, VmSearch, CreateDeliveryBillDialog },
    data() {
      return {
        createAuth: this.$auth(239),
        exportLoading: false,
        filter: {
          isFinished: 1,
          pcorderNo: "",
          purchaseOrderNo:"",
          straightMark:-1,
        },
        selection: [], // 选中的供应商
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      // 查询
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      // 供应商选中
      selectHandle(selection) {
        this.selection = selection;
      },
      // 创建送货单
      createDeliverySlip() {
        if (!this.selection.length) {
          this.$confirm("请选择采购订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        }else {
          const straightMark = this.selection.every((item)=> item.straightMark === this.selection[0].straightMark);
          const result = this.selection.every((item) => item.supplierNo === this.selection[0].supplierNo);
          const location = this.selection.every((item) => item.location === this.selection[0].location);
          if (result && straightMark && location) {
            this.$refs.createDeliveryBillDialog.open  (0,this.selection);
          } else if(!result) {
            this.$confirm("供应商不一致,请重新选择", "错误", {
              type: "error",
              showCancelButton: false,
            });
          }else if(!straightMark) {
            this.$confirm("直发标识不一致,请重新选择", "错误", {
              type: "error",
              showCancelButton: false,
            });
          }else if(!location) {
            this.$confirm("仓位不一致,请重新选择", "错误", {
              type: "error",
              showCancelButton: false,
            });
          }
        }
      },

      // 导出
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "sAPPurchaseOrderDetails/export", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style>
.el-table-column--selection .cell {
  padding-right: 10px;
}
</style>
